<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4">
  <div class="form-group row">
    <div class="col-md-6">
      <yt-fw-date-picker-popup formControlName="DatumOd" name="txtDatumOd" [Label]="'REKAPITULACIJAIZLAZAPOARTIKLIMA.DATUMOD.SINGULAR'">
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.DatumOd.invalid">
        <span *ngFor="let validation of errorMessages.DatumOd">
          <span class="error-message" *ngIf="fc.DatumOd.hasError(validation.type)">
            <span [ngClass]="{'slideInRight': fc.DatumOd.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
    <div class="col-md-6">
        <yt-fw-date-picker-popup formControlName="DatumDo" name="txtDatumDo" [Label]="'REKAPITULACIJAIZLAZAPOARTIKLIMA.DATUMDO.SINGULAR'">
        </yt-fw-date-picker-popup>
        <div class="form-error" *ngIf="submitted && fc.DatumDo.invalid">
          <span *ngFor="let validation of errorMessages.DatumDo">
            <span class="error-message" *ngIf="fc.DatumDo.hasError(validation.type)">
              <span [ngClass]="{'slideInRight': fc.DatumDo.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span></span>
          </span>
        </div>
      </div>
    </div>
    
  <div class="form-group row">
    <div class="col-md-6">
      <yt-multiselect
                    [ModelName]="'orgjed'"
                    [GetName]="'getParentAndChildByParentID'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    formControlName="OrgJedID"
                    [AllowAddNew]="false" 
                    [Type]="'ID'"
                    [Label]="'REKAPITULACIJAIZLAZAPOARTIKLIMA.ORGJEDNAZIV.SINGULAR'"
                    [ngClass]="{'is-invalid': submitted && fc.OrgJedID.invalid}"
                    >
      </yt-multiselect>
      <div class="form-error" *ngIf="submitted && fc.OrgJedID.invalid">
        <span *ngFor="let validation of errorMessages.OrgJedID">
          <span class="error-message" *ngIf="fc.OrgJedID.hasError(validation.type)">
            <span [ngClass]="{'slideInRight': fc.OrgJedID.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>

    <div class="col-md-6">
      <yt-multiselect
                    [ModelName]="'robnagrupa'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    formControlName="RobnaGrupaID"
                    [AllowAddNew]="false" 
                    [Type]="'ID'"
                    [Label]="'REKAPITULACIJAIZLAZAPOARTIKLIMA.ROBNAGRUPANAZIV.SINGULAR'"
                    [ngClass]="{'is-invalid': submitted && fc.RobnaGrupaID.invalid}"
                    >
       </yt-multiselect>
      <div class="form-error" *ngIf="submitted && fc.RobnaGrupaID.invalid">
        <span *ngFor="let validation of errorMessages.RobnaGrupaID">
          <span class="error-message" *ngIf="fc.RobnaGrupaID.hasError(validation.type)">
            <span [ngClass]="{'slideInRight': fc.RobnaGrupaID.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-6">
      <yt-multiselect
                    [ModelName]="'komitent'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    formControlName="KomitentID"
                    [AllowAddNew]="false" 
                    [Type]="'ID'"
                    [Label]="'REKAPITULACIJAIZLAZAPOARTIKLIMA.KOMITENTNAZIV.SINGULAR'"
                    [ngClass]="{'is-invalid': submitted && fc.KomitentID.invalid}"
                    >
       </yt-multiselect>
       <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
        <span *ngFor="let validation of errorMessages.KomitentID">
          <span class="error-message" *ngIf="fc.KomitentID.hasError(validation.type)">
            <span [ngClass]="{'slideInRight': fc.KomitentID.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
    <div class="col-md-6">
      <yt-multiselect
                    [ModelName]="'proizvodjac'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    formControlName="ProizvodjacID"
                    [AllowAddNew]="false" 
                    [Type]="'ID'"
                    [Label]="'REKAPITULACIJAIZLAZAPOARTIKLIMA.PROIZVODJACNAZIV.SINGULAR'"
                    [ngClass]="{'is-invalid': submitted && fc.ProizvodjacID.invalid}"
                    >
      </yt-multiselect>
      <div class="form-error" *ngIf="submitted && fc.ProizvodjacID.invalid">
        <span *ngFor="let validation of errorMessages.ProizvodjacID">
          <span class="error-message" *ngIf="fc.ProizvodjacID.hasError(validation.type)">
            <span [ngClass]="{'slideInRight': fc.ProizvodjacID.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-4">
      <cascade-dropdown
        [ModelName]="'commonString'"
        [ModelProperty]="'Name'"
        [Source]="source"
        formControlName="SortBy"
        [Label]="'REKAPITULACIJAIZLAZAPOARTIKLIMA.SORTIRANJE.SINGULAR'"
        (OnItemSelected)="sortByItemSelected($event)">
      </cascade-dropdown>
    </div>
  </div>
  <div class="row mt-2">
      <div class="col-md-12">  
        <button type="button" class="btn btn-primary" (click)="LoadPDF()">
          <span class="fa fa-fw fa-print"></span>Štampaj
        </button>
      </div>
  </div>

</form>



